
// const stripePromise = loadStripe(
//     process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ""
//   );

import axios from 'axios';
import React, { useState } from 'react';
import { Modal, Button, Typography, Box, TextField } from '@mui/material';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, useStripe, useElements } from '@stripe/react-stripe-js';

// Load Stripe with your public key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "");

const CardDetailsModal = ({ open, onClose }) => {
  const [error, setError] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [cvc, setCvc] = useState('');
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return; // Ensure Stripe is ready
    }

    // Validate the inputs
    const [expiryMonth, expiryYear] = expiryDate.split('/');
    if (!cardNumber || !expiryMonth || !expiryYear || !cvc) {
      setError('Please complete all card details.');
      return;
    }

    try {
      // Make the token creation request to your server
      const response = await axios.post(
        'https://api.stripe.com/v1/tokens',
        new URLSearchParams({
          'card[number]': cardNumber,
          'card[exp_month]': expiryMonth.trim(),
          'card[exp_year]': expiryYear.trim(),
          'card[cvc]': cvc,
          'card[currency]': 'usd',
        }),
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ""}`,
          },
        }
      );

      console.log('Token Created:', response.data.id);
      onClose(response.data.id);
      return response.data; // Contains the token to use later
    } catch (error) {
      onClose('');
      console.log(JSON.stringify(error));
      if (axios.isAxiosError(error)) {
        if (error.response) {
          // Server responded with a status code outside the 2xx range
          const errorDetails = error.response.data;
          console.error('Stripe Error:', errorDetails);
      
          // Extract meaningful message
          const message = errorDetails.error?.message || 'An error occurred while processing your payment.';
      
          // Show error to user
          alert(message);
        } else alert("Something went wrong");
      } else alert("Something went wrong");
      throw error;
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => onClose(null)} // Close without token if user cancels
      aria-labelledby="card-details-modal"
      aria-describedby="modal-to-enter-card-details"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Enter Card Details
        </Typography>

        <form onSubmit={handleSubmit}>
          {/* Custom text input fields */}
          <div style={{ marginBottom: '1rem' }}>
            <TextField
              label="Card Number"
              fullWidth
              value={cardNumber}
              onChange={(e) => setCardNumber(e.target.value)}
              variant="outlined"
              inputProps={{ maxLength: 16 }}
              style={{ borderRadius: '8px' }}
            />
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <TextField
              label="Expiration Date (MM/YY)"
              fullWidth
              value={expiryDate}
              onChange={(e) => setExpiryDate(e.target.value)}
              variant="outlined"
              inputProps={{ maxLength: 5 }} // Limit input to MM/YY format
              style={{ borderRadius: '8px' }}
            />
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <TextField
              label="CVC"
              fullWidth
              value={cvc}
              onChange={(e) => setCvc(e.target.value)}
              variant="outlined"
              inputProps={{ maxLength: 4 }} // CVC can be 3 or 4 digits
              style={{ borderRadius: '8px' }}
            />
          </div>

          {/* Show error message if there's an issue */}
          {error && <Typography color="error">{error}</Typography>}

          <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => onClose(null)} // Close modal without token
            >
              Cancel
            </Button>
            <Button variant="contained" color="primary" type="submit" disabled={!stripe}>
              Submit
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};

const StripeCardDetailsModalWrapper = ({ open, onClose }) => {
  return (
    <Elements stripe={stripePromise}>
      <CardDetailsModal open={open} onClose={onClose} />
    </Elements>
  );
};

export default StripeCardDetailsModalWrapper;
